import "./App.css";
import API from "./api/api";
import { useEffect, useState } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import AppRoutes from "./router";
import Loader from "../src/Components/Loader/Loader";
import { GOOGLE_MAP_KEY } from "./api/constants";
import { GlobalProvider } from "./context/PaginationGlobal";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { getPermissions, initPermissions } from "./context/PermissionManager";
import { ToastContainer } from "react-toastify";

function App() {
  const [loading, setLoading] = useState(false);
  const queryClient = new QueryClient();
  const token = localStorage.getItem("token");

  useEffect(() => {
    initPermissions();

    const requestInterceptor = API.interceptors.request.use(
      function (config) {
        setLoading(true);
        return config;
      },
      function (error) {
        setLoading(false);
        return Promise.reject(error);
      }
    );

    const responseInterceptor = API.interceptors.response.use(
      function (response) {
        setLoading(false);
        return response;
      },
      function (error) {
        setLoading(false);
        return Promise.reject(error);
      }
    );

    getPermissions();

    return () => {
      API.interceptors.request.eject(requestInterceptor);
      API.interceptors.response.eject(responseInterceptor);
    };
  }, [token]);

  return (
    <div>
      <QueryClientProvider client={queryClient}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          {loading && <Loader />}
          <GlobalProvider>
            <AppRoutes />
            <ToastContainer />
          </GlobalProvider>
        </LocalizationProvider>
      </QueryClientProvider>
    </div>
  );
}

export default App;
